export const viVN_avatorDropMenu = {
  'header.avator.profile': 'Thông tin cá nhân',
  'header.avator.logout': 'Đăng xuất',
  'global.theme.switchTheme': 'Switch Theme',
  'global.theme.switchingTheme': 'Switching Theme...',
  'global.theme.switchThemeDone': 'Update theme successfully!',
  'global.theme.switchThemeFail': 'Update theme fail'
};
